import React from "react";
import "./DiscoverImage.css";

const DiscoverImage = () => {
  return (
    <div className="image-wrap">
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/about.jpeg`}
        alt="About"
      />
    </div>
  );
};

export default DiscoverImage;
